import React, { Component } from 'react';
import PanelView from '../model/PanelView.js';
import {clone, getRoomName, getLeaderName, formatDate, toCSV, trimLocation} from '../util/Utility.js';
import { Glyphicon } from 'react-bootstrap';

export default class Approval3PanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
    };

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  render() {

    var object = this.state.object;

    return (
      <PanelView type="approval3" subtype="event" edit delete approve contact setState={this.setState.bind(this)} object={object} {...this.props}>
        <center>
          <h2 style={{margin: 0}}>{object.title}</h2>
          <p className="popoverTextHeader">{formatDate(object.date, object.endDate)}</p>
        </center>
        <div style={{height: 7}} />
        <p>{object.description}</p>
        <p><Glyphicon glyph="user" /> Created By {getLeaderName(object.originator)}</p>
        <p><Glyphicon glyph="map-marker" /> Located at {object.atCCO ? "CCO in the " + getRoomName(object) : trimLocation(object.location)}</p>
        <p><b>Technical Setup Needed: </b>{toCSV(object.techSetup) || "None"}</p>
      </PanelView>
    );

  }
}



/** WEBPACK FOOTER **
 ** ./src/approvals/Approval3PanelView.js
 **/